/**
* A method that sets up the routes for this module
*/
export const initialise = () => {
  angular.module('app.abt-configuration').config([
    '$stateProvider',
    '$urlRouterProvider',
    '$locationProvider',
    ($stateProvider, $urlRouterProvider, $locationProvider) => {
    $locationProvider.hashPrefix('');

    $stateProvider.state('taps-report', {
      url: '/taps-report',
      templateUrl: 'app/angularJS/features/abt/taps-report/taps-report.html',
      controller: 'tapsReportController',
      controllerAs: 'vm',
      parent: 'common'
    });

    $urlRouterProvider.otherwise('/');
  }]);
}